/*
  Split The V — add-to-cart toast (hoort bij snippets/stv-toast.liquid)

  Drie lagen, zodat de toast bij ELKE add-to-cart verschijnt:
  1. window.STVToast — publiek API'tje (show/hide + cart-bubble verversen).
  2. Custom element 'cart-notification' — shim die inhaakt op Dawn's
     product-form.js (alleen als Dawn zelf geen cart-notification/drawer
     geladen heeft, d.w.z. cart_type == "page").
  3. window.fetch-hook op /cart/add — vangt overige toevoegingen op
     (sticker-upsell, reorder-pagina, toekomstige knoppen).

  De bestaande add-to-cart-logica (Shopify AJAX Cart API), de cart guard en
  de sticker-upsell blijven onaangeroerd; dit is puur visuele bevestiging.
*/
(function () {
  'use strict';

  var HIDE_AFTER_MS = 4500;
  var DEBOUNCE_MS = 400;

  var hideTimer = null;
  var lastShown = 0;

  function toastEl() {
    return document.getElementById('stv-toast');
  }

  function show() {
    var el = toastEl();
    if (!el) return;
    var now = Date.now();
    if (now - lastShown < DEBOUNCE_MS) {
      // Dubbele trigger (shim + fetch-hook) voor dezelfde actie: alleen timer verlengen.
      clearTimeout(hideTimer);
      hideTimer = setTimeout(hide, HIDE_AFTER_MS);
      return;
    }
    lastShown = now;
    el.classList.add('is-visible');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hide, HIDE_AFTER_MS);
  }

  function hide() {
    var el = toastEl();
    if (!el) return;
    clearTimeout(hideTimer);
    el.classList.remove('is-visible');
  }

  // Vervangt de inhoud van de cart-teller in de header met een via de
  // Section Rendering API gerenderde 'cart-icon-bubble' sectie.
  function updateCartBubble(sectionHtml) {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || !sectionHtml) return;
    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var inner = doc.querySelector('.shopify-section') || doc.body;
    bubble.innerHTML = inner.innerHTML;
  }

  function refreshCartBubble() {
    fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '?section_id=cart-icon-bubble')
      .then(function (res) { return res.ok ? res.text() : null; })
      .then(function (html) { if (html) updateCartBubble(html); })
      .catch(function () { /* teller verversen is nice-to-have */ });
  }

  window.STVToast = {
    show: show,
    hide: hide,
    updateCartBubble: updateCartBubble,
    refreshCartBubble: refreshCartBubble
  };

  function init() {
    var el = toastEl();
    if (!el) return;
    var close = el.querySelector('[data-stv-toast-close]');
    if (close) close.addEventListener('click', hide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ── Shim voor Dawn's product-form.js ─────────────────────────────────
     product-form.js doet: document.querySelector('cart-notification') ||
     document.querySelector('cart-drawer'); zonder resultaat volgt een harde
     redirect naar de cart-pagina. Deze shim implementeert precies de
     interface die product-form.js aanroept (getSectionsToRender,
     setActiveElement, renderContents) en toont de toast in plaats van de
     redirect. Alleen gedefinieerd als Dawn het element zelf niet levert. */
  if (!customElements.get('cart-notification') && document.querySelector('[data-stv-toast-shim]')) {
    customElements.define(
      'cart-notification',
      class STVCartNotificationShim extends HTMLElement {
        getSectionsToRender() {
          return [{ id: 'cart-icon-bubble' }];
        }
        setActiveElement(element) {
          this.activeElement = element;
        }
        renderContents(parsedState) {
          if (parsedState && parsedState.sections && parsedState.sections['cart-icon-bubble']) {
            updateCartBubble(parsedState.sections['cart-icon-bubble']);
          } else {
            refreshCartBubble();
          }
          show();
        }
      }
    );
  }

  /* ── Vangnet: /cart/add-hook ──────────────────────────────────────────
     Toont de toast bij elke geslaagde toevoeging die niet via de shim of
     stv-sunset.js loopt (bijv. de sticker-upsell op de productpagina).
     Zelfde patroon als de bestaande cart guard (cart-sticker-guard):
     window.fetch wordt gewrapt, het gedrag van de call zelf blijft intact. */
  var originalFetch = window.fetch;
  window.fetch = function (url) {
    var result = originalFetch.apply(this, arguments);
    var target = typeof url === 'string' ? url : (url && url.url) || '';
    if (target.indexOf('/cart/add') !== -1) {
      result.then(function (response) {
        if (response && response.ok) {
          show();
          refreshCartBubble();
        }
      }).catch(function () { /* fout wordt door de aanroeper afgehandeld */ });
    }
    return result;
  };
})();
